import React, {FC} from 'react';
import styled from 'styled-components';

import {Plural, Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {ButtonVariantsEnum} from '../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {OkCancelDialog} from '../../../../../libs/shared/ui/src/components/dialogs/okCancelDialog';

/*
 * Types.
 */

interface ChatBotBuilderNodeSubtreeUpdateWarningDialogProps {
  numSubtreeUses: number;
  onRequestClose: () => void;
  onSave: () => void;
}

/*
 * Styles.
 */

const StyledDialogDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const StyledContentDiv = styled.div`
  line-height: 22px;
`;

/*
 * Component.
 */

export const ChatBotBuilderNodeSubtreeUpdateWarningDialog: FC<
  ChatBotBuilderNodeSubtreeUpdateWarningDialogProps
> = ({numSubtreeUses, onRequestClose, onSave}) => {
  const onSaveClick = () => {
    onSave();
    onRequestClose();
  };

  return (
    <OkCancelDialog
      okButtonVariant={ButtonVariantsEnum.PRIMARY}
      title={
        <Trans id="flow-builder-node-subtree-update-warning-dialog-title">
          Changes will affect your main flow
        </Trans>
      }
      okButtonLabel={<Trans id="flow-builder-node-subtree-update-warning-dialog-confirm">Save</Trans>}
      onRequestClose={onRequestClose}
      onOkClick={onSaveClick}
    >
      <StyledDialogDiv>
        <StyledContentDiv>
          <Trans id="flow-builder-node-subtree-update-warning-dialog-content-1">
            A branching implementation of this saved flow is
          </Trans>{' '}
          <Plural
            id="flow-builder-node-subtree-update-warning-dialog-uses-count"
            value={numSubtreeUses}
            one="used # time"
            other="used # times"
          />{' '}
          <Trans id="flow-builder-node-subtree-update-warning-dialog-content-2">in your main flow.</Trans>
        </StyledContentDiv>
        <StyledContentDiv>
          <Trans id="flow-builder-node-subtree-update-warning-dialog-content-3">
            Once changes are saved, please review your main flow to ensure each branch has the intended next
            step.
          </Trans>
        </StyledContentDiv>
      </StyledDialogDiv>
    </OkCancelDialog>
  );
};
